/**
 * PriceCheckCounter — Free-tier usage pill
 *
 * Shows "{used} of {limit} Price Checks" using existing token-based pill style.
 * Switches to warning style at limit. Hidden entirely for premium users.
 */

import { T } from '@/styles/tokens';

interface PriceCheckCounterProps {
  used: number;
  limit: number;
  isPremium: boolean;
}

export function PriceCheckCounter({ used, limit, isPremium }: PriceCheckCounterProps) {
  if (isPremium) return null;
  const isWarning = used >= limit;
  return (
    <span
      style={{
        display: 'inline-flex',
        alignItems: 'center',
        padding: '4px 10px',
        borderRadius: T.radiusSm,
        fontSize: 11,
        fontWeight: 600,
        letterSpacing: '0.02em',
        textTransform: 'uppercase',
        fontFamily: T.fontFamily,
        background: isWarning ? 'rgba(224,122,61,0.10)' : T.primarySubtle,
        color: isWarning ? T.warning : T.textSecondary,
      }}
    >
      {used} of {limit} Price Checks
    </span>
  );
}

export default PriceCheckCounter;
